/*
 * Author M. Atoar Rahman
 * Title: Drug Manufacturer
 * Description: Page for Drug Manufacturer
 * Date: 15/03/2022
 */

import React from 'react';
import { Card } from 'react-bootstrap';
import { useAuth } from '../../contexts/AuthContext';
import { ManufacturerProvider } from '../masterSetup/manufacturer/ContextAPI';
import DataTable from '../masterSetup/manufacturer/DataTable';
import FormInfo from '../masterSetup/manufacturer/FormInfo';
import PermissionDenied from './PermissionDenied';

export default function DrugManufacturer() {
    // Route Permission
    const { auth } = useAuth();
    const { route_permissions } = auth;
    if (!route_permissions['drug-manufacturer']) return <PermissionDenied />;

    return (
        <ManufacturerProvider>
            <Card>
                <Card.Header className="cardHeader">
                    <h3>Drug Manufacturer</h3>
                    <div>
                        <FormInfo />
                    </div>
                </Card.Header>
                <Card.Body>
                    <DataTable />
                </Card.Body>
            </Card>
        </ManufacturerProvider>
    );
}
